export default __webpack_public_path__ + "static/media/noverde-symbol.2225d43f.svg";